module.exports = __webpack_public_path__ + "static/media/phoneIcon.30b5008b.svg";